import { Chord, Section } from "../backingTrackGenerator/editorStore/backingTrackGeneratorEditorState"
import { BARS_BY_LINE, LENGTH_16TH, LINE_HEIGHT, LINE_MARGIN_BOTTOM, SECTION_HEADER_HEIGHT, SECTION_MARGIN_BOTTOM, TOTAL_LINE_HEIGHT, TT_BY_LINE } from "./constants"

export const simplifyNote = (note: string) => {

  if (parseInt(note[note.length - 1]) !== NaN)
    return note.slice(0, note.length - 1)
  
  return note
}

export const simplifyNoteWithOct = (note: string) => {

  if (parseInt(note[note.length - 1]) !== NaN)
    return {
      name: note.slice(0, note.length - 1),
      oct: note[note.length - 1]
    }
  
  return {
    name: note
  }
}

export const isArrayInjection = (a1: any[], a2: any[]) => {
	for (let i = 0; i < a1.length; i++) {
		if (!a2.includes(a1[i]))
			return false
	}
	
	return true
}

export const compareObjects = (o1: any, o2: any): any => {
	if (!o1 || !o2) return

	console.log({ compareObjects: { o1, o2 } })
	
	const diff = Object.keys(o2).reduce((diff, key) => {
		if (o1[key] === o2[key]) return diff

		if (typeof o1[key] === 'object' && o1[key] && o2[key]) {
			const diff2 = compareObjects(o1[key], o2[key])
			return {
				...diff,
				[key]: diff2
			}
		}

		return {
			...diff,
			[key]: {
				o1: o1[key],
				o2: o2[key]
			}
		}
	}, {})

	return diff
}

const getTtArray = (tt: string) => {
	const array = tt.split(':').map((str: string) => parseInt(str))

	const toTt2 = (str: number) => str ? str : 0
	
	return [toTt2(array[0]), toTt2(array[1]), toTt2(array[2])]
}

export const ttTo16th = (tt: string) => {
	const array = getTtArray(tt)

	const ret = (array[0] || 0) * 16 + (array[1] || 0) * 4 + (array[2] || 0)

	return ret
}

export const time16thtoTt = (time: number) => {
	const array = [Math.trunc(time / 16)]
	
	array.push(Math.trunc((time - array[0] * 16) / 4))
	
	array.push(Math.trunc((time - array[0] * 16 - array[1] * 4) / 1))

	return array.join(':')
}

// tt1 <= tt < tt1 + ttd
export const isTtInBetween = (tt: string, tt1: string, ttd: string) => ttTo16th(tt1) <= ttTo16th(tt) && ttTo16th(tt) < ttTo16th(tt1) + ttTo16th(ttd)

export const addTts = (tt1: string, tt2: string) => time16thtoTt(ttTo16th(tt1) + ttTo16th(tt2))

export const multTt = (tt: string, n: number) => time16thtoTt(ttTo16th(tt) * n)

export const divTt = (tt: string, n: number) => time16thtoTt(ttTo16th(tt) / n)

export const modTt = (tt: string, n: number) => time16thtoTt(ttTo16th(tt) % (n * 16))

export const toTt = (str: string) => getTtArray(str).join(':')

export const substractTts = (tt1: string, tt2: string) => time16thtoTt(ttTo16th(tt1) - ttTo16th(tt2))

export const getPrevRoundTt = (tt1: string, tt2: string, subdivtt: string, timeSignatureUpper: number = 4) =>
	time16thtoTt(Math.ceil((ttTo16th(tt1) - ttTo16th(tt2)) / ttTo16th(subdivtt)) * ttTo16th(subdivtt))

export const getNextRoundTt = (tt1: string, tt2: string, subdivtt: string, timeSignatureUpper: number = 4) =>
	time16thtoTt(Math.floor((ttTo16th(tt1) + ttTo16th(tt2)) / ttTo16th(subdivtt)) * ttTo16th(subdivtt))

// export const getChordsLength = (sections: Section[], max?: number) =>
// 	sections.reduce((acc: number, section: any, i: number) => max === undefined || i < max ? acc + section.chords.length : acc, 0)

export const getTotalTtDuration = (sections: Section[], max?: number) =>
	sections.reduce((acc: string, section: any, i: number) => max === undefined || i < max ? addTts(acc, section.transportTimeDuration) : acc, '0:0')

export const compareTts = (tt1: string, tt2: string) =>
	ttTo16th(tt1) < ttTo16th(tt2) ? 1 : ttTo16th(tt1) > ttTo16th(tt2) ? -1 : 0

export const isTtInBetweenTtRange = (tt: string, r: string[]) =>
	compareTts(r[0], tt) === 1 && compareTts(tt, addTts(r[0], r[1])) === 1

export const isTtInBetweenIncludeTtRange = (tt: string, r: string[]) =>
	compareTts(r[0], tt) >= 0 && compareTts(tt, addTts(r[0], r[1])) >= 0

// r1 = [tt, ttDuration]
export const ttsRangesCollide = (r1: [string, string], r2: [string, string]) =>
	isTtInBetweenTtRange(addTts(r1[0], r1[1]), r2) || isTtInBetweenTtRange(r1[0], r2) ||
	isTtInBetweenTtRange(addTts(r2[0], r2[1]), r1) || isTtInBetweenTtRange(r2[0], r1)

export const ttsRangesArrayCollide = (r1: [string, string], rArray: [string, string][]) =>
	rArray.some((r: [string, string]) => ttsRangesCollide(r1, r) || (compareTts(r[0], r1[0]) === 0 && compareTts(r[1], r1[1]) === 0))


// Battle tested !!!
export const ttsRangesCollideInclude = (r1: [string, string], r2: [string, string]) =>
	isTtInBetweenIncludeTtRange(addTts(r1[0], r1[1]), r2) || isTtInBetweenIncludeTtRange(r1[0], r2) ||
	isTtInBetweenIncludeTtRange(addTts(r2[0], r2[1]), r1) || isTtInBetweenIncludeTtRange(r2[0], r1)

export const ttsRangeIsInBetween = (r1: [string, string], r2: [string, string]) =>
	isTtInBetweenTtRange(r1[0], r2) && isTtInBetweenTtRange(addTts(r1[0], r1[1]), r2)

// r1 in -> r2
export const ttsRangeIsInBetweenInclude = (r1: [string, string], r2: [string, string]) =>
	isTtInBetweenIncludeTtRange(r1[0], r2) && isTtInBetweenIncludeTtRange(addTts(r1[0], r1[1]), r2)

// r2		[--] -> 1			[--] -> -1		[--]	-> 0		[------]	-> 2		-> undefined
// r1	[--]							[--]			[------]					[--]
export const ttRangesCross = (r1: [string, string], r2: [string, string]) =>
	ttsRangeIsInBetweenInclude(r2, r1) ? 0 : ttsRangeIsInBetweenInclude(r1, r2) ? 2 : ttsRangesCollide(r1, r2) ? compareTts(r1[0], r2[0]) : undefined

export const isChordStartOfSection = (sections: Section[], chord: Chord) =>
	sections.some((section: Section) => compareTts(chord.transportTime, section.transportTime) === 0)

// TODO : could be a lot faster, since chord are chronologically ordered, just check for the next chord
export const hasNextAdjacentChord = (chords: Chord[], chord: Chord) =>
	chords.some((c: Chord) => compareTts(addTts(chord.transportTime, chord.transportTimeDuration), c.transportTime) === 0)


// get Chords in range ([tt, ttDuration]) (include chords that are between two ranges)
export const getChordsInTtRange = (chords: Chord[], ttRange: [string, string]) =>
	chords.filter((chord: Chord) => ttsRangesCollide([chord.transportTime, chord.transportTimeDuration], ttRange))

export const getChordsInRange = (chords: Chord[], ttTange: [number, number]) => {
	const chords2: Chord[] = []
  for (let i = ttTange[0]; i <= ttTange[1]; i++) {
    chords2.push(chords[i])
	}
	return chords2
}

export const getRangeSE = (range: [string, string]): [string, string] => [range[0], addTts(range[0], range[1])]

export const getTtRangesIntersectInclude = (ranges: [string, string][], range: [string, string]) =>
	ranges.filter((r: [string, string]) => ttsRangesCollideInclude(range, r))

/* Chord Utils */

export const getRange = (el: Chord | Section): [string, string] => [el.transportTime, el.transportTimeDuration]

export const getEndTt = (el: Chord | Section): string => addTts(el.transportTime, el.transportTimeDuration)

// [start, end]
export const getChordRangeSE = (chord: Chord) => getRangeSE(getRange(chord))

/* Position */

export const getLeftPositionFromTt2 = (sections: Section[], sectionIndex: number, tt: string, lineIndex: number) =>
	(ttTo16th(substractTts(tt, getTotalTtDuration(sections, sectionIndex))) - ttTo16th((lineIndex * BARS_BY_LINE).toString())) * LENGTH_16TH

export const getSectionAndLineIndexesFromTt = (sections: Section[], tt: string, globalLineIndex?: number) => {
	// return { sectionIndex: 0, lineIndex: 0 }
	let currTt = '0:0'
	let prevTt: string

	let sectionIndex = 0

	while(compareTts(currTt, globalLineIndex ? (globalLineIndex * BARS_BY_LINE) + ':0' : tt) >= 0) {
		prevTt = currTt
		currTt = addTts(currTt, sections[sectionIndex].transportTimeDuration)
		// console.log({ tt, sectionIndex, total: sections[sectionIndex].transportTimeDuration })
		sectionIndex++
	} 
	sectionIndex--
	currTt = substractTts(currTt, sections[sectionIndex].transportTimeDuration)

	// console.log({ tt, currTt })

	let lineIndex = globalLineIndex ? globalLineIndex - parseInt(currTt.split(':')[0]) / BARS_BY_LINE : Math.floor(parseInt(substractTts(tt, prevTt!).split(',')[0]) / BARS_BY_LINE)

	return {
		sectionIndex,
		lineIndex
	}
}


export const getGlobalLineIndex = (sections: Section[], sectionIndex: number, lineIndex: number) =>
	getSectionsLineCount(sections, sectionIndex) + lineIndex

export const getLineIndexFromTt = (tt: string) => Math.floor(parseInt(tt.split(':')[0]) / BARS_BY_LINE)

// lineIndex? use to render cross chord cards (between lines & between sections)
export const getPositionFromTt = (sections: Section[], tt: string, globalLineIndex?: number) => {
	const { sectionIndex, lineIndex } = getSectionAndLineIndexesFromTt(sections, tt, globalLineIndex)
	
	let currTop = SECTION_HEADER_HEIGHT
	let currTt = '0:0'
	// console.log('')
	// console.log({ tt, sectionIndex, globalLineIndex, lineIndex })

	for (let i = 0; i < sectionIndex; i++) {
		currTop += getSectionHeight(sections[i])
		// currTt = addTts(currTt, sections[i].transportTimeDuration)// TODO might not work if line is less that 4 bars
		// currTt = addTts(currTt, sections[sectionIndex].transportTimeDuration)
	}

	// if (sectionIndex > 0) {
	// 	currTt = substractTts(currTt, sections[sectionIndex].transportTimeDuration)
	// }

	currTop += TOTAL_LINE_HEIGHT * lineIndex

	currTt = addTts(currTt, getTotalTtDuration(sections, sectionIndex))
	currTt = addTts(currTt, (BARS_BY_LINE * lineIndex) + ':0')

	// const left = ttTo16th(modTt(tt, BARS_BY_LINE)) * LENGTH_16TH
	const left = ttTo16th(substractTts(tt, currTt)) * LENGTH_16TH

	// console.log({ currTt, globalLineIndex, sectionIndex, lineIndex, left })


	return {
		top: currTop,
		left
	}
}


export const getWidthFromTtDuration = (ttDuration: string) => ttTo16th(ttDuration) * LENGTH_16TH

/* Drag Position */

export const getSectionLinesCount = (section: Section) =>
	parseInt(section.transportTimeDuration.split(':')[0]) / BARS_BY_LINE

export const getSectionsLineCount = (sections: Section[], sectionIndex: number) => {
	let count = 0

	for (let i = 0; i < sectionIndex; i++) {
		count += getSectionLinesCount(sections[i])
	}

	return count
}

export const getSectionHeight = (section: Section) =>
	getSectionLinesCount(section) * TOTAL_LINE_HEIGHT + SECTION_HEADER_HEIGHT + SECTION_MARGIN_BOTTOM

export const getSectionTop = (sections: Section[], sectionIndex: number = sections.length) =>
	sections.reduce((count: number, section: Section, i: number) => i < sectionIndex ? count + getSectionHeight(section) : count, 0)

export const getLineTop = (sections: Section[], sectionIndex: number, lineIndex: number) =>
	getSectionTop(sections, sectionIndex) + lineIndex * TOTAL_LINE_HEIGHT + SECTION_HEADER_HEIGHT


// TODO : test those two when multi select available
export const sortChordSelectedRanges = (chordSelectedRanges: [number, number][]) =>
	chordSelectedRanges.sort((r1: [number, number], r2: [number, number]) => r1[0] < r2[0] ? 1 : r1[0] > r2[0] ? -1 : 0)

export const sortCursorRanges = (cursorRanges: [string, string][]) =>
	cursorRanges.sort((r1: [string, string], r2: [string, string]) => compareTts(r1[0], r2[0]))

export const sortChords = (chords: Chord[]) =>
	deepCopy(chords).sort((c1: Chord, c2: Chord) => compareTts(c2.transportTime, c1.transportTime))

export const getTtFromX = (x: number) => time16thtoTt(Math.round(x / LENGTH_16TH))

export const getTtFromX2 = (x: number, sections: Section[], lineIndex: number, sectionIndex: number) =>
	addTts(addTts(getTtFromX(x), multTt(TT_BY_LINE, lineIndex)), getTotalTtDuration(sections, sectionIndex))

// OK.. là c'est wow
export const getTtFromY2 = (y: number, sections: Section[], tt: string) => // tt needed to change offsets
	sections.reduce(
		(count: string, section: Section, sectionIndex: number) => {
			console.log({ sectionIndex, sectionTop: getSectionTop(sections, sectionIndex), y, count, tt })
			return getSectionTop(sections, sectionIndex + 1) + (compareTts(count, tt) === 1 ? SECTION_HEADER_HEIGHT : 0) <= y ? addTts(count, section.transportTimeDuration) :
				Array.from(Array(getSectionLinesCount(section))).reduce(
					(count2: string, _, lineIndex: number) => {
						// console.log({ sectionIndex, lineIndex, lineTop: getLineTop(sections, sectionIndex, lineIndex), y, count2, tt })
						return getLineTop(sections, sectionIndex, lineIndex + 1) +
							(lineIndex === getSectionLinesCount(section) - 1 && compareTts(count, tt) === 1 ? SECTION_HEADER_HEIGHT + SECTION_MARGIN_BOTTOM : 0) <= y ? addTts(count2, TT_BY_LINE) : count2}, count)}, '0:0')

export const getLineTtFromLineY = (y: number, linesLength: number, tt?: string, twice: boolean = false): any => {
	let currTt = '0:0'
	let currTop = 0

	let lineIndex = 0
	// console.log({ currTop, lineIndex, currTop_LINE_HEIGHT: currTop + TOTAL_LINE_HEIGHT })
	for(; currTop + (!twice ? 0 : -LINE_MARGIN_BOTTOM) + TOTAL_LINE_HEIGHT + (lineIndex === linesLength - 1 ? SECTION_HEADER_HEIGHT + SECTION_MARGIN_BOTTOM : 0) <= y; lineIndex++) {
		currTt =	addTts(currTt, TT_BY_LINE)
		currTop += TOTAL_LINE_HEIGHT// + SECTION_HEADER_HEIGHT
		// console.log({ currTop, lineIndex, currTop_LINE_HEIGHT: currTop + TOTAL_LINE_HEIGHT })
	}

	// si currLine + line < prevLine
	if (!twice && tt && compareTts(addTts(currTt, '4:0'), tt) > -1) {
		return getLineTtFromLineY(y, linesLength, tt, true)
	}

	return {
		yLineTt: currTt,
		lineIndex,
	}
}

// OK.. là c'est déjà mieux haha
export const getTtFromY = (y: number, sections: Section[], tt?: string, twice: boolean = false): any => {// tt needed to change offsets

	// console.log('')
	// console.log('getTtFromY :')
	// console.log({ y, tt })
	
	let currTt = '0:0'
	let currTop = 0

	let sectionIndex = 0

	let globalLineIndex = 0
	// console.log({ currTop, sectionIndex, sectionHeight: getSectionHeight(sections[sectionIndex]) })
	// Do not go to next section if mouse isnt under next header
	for(; currTop + getSectionHeight(sections[sectionIndex]) + (!twice ? SECTION_HEADER_HEIGHT : -(SECTION_MARGIN_BOTTOM + LINE_MARGIN_BOTTOM)) <= y; sectionIndex++) {
		currTt = addTts(currTt, sections[sectionIndex].transportTimeDuration)
		currTop += getSectionHeight(sections[sectionIndex])
		// console.log({ currTop, sectionIndex })
		globalLineIndex += getSectionLinesCount(sections[sectionIndex])
	}

	currTop += SECTION_HEADER_HEIGHT

	const { yLineTt, lineIndex } = getLineTtFromLineY(y - currTop, getSectionLinesCount(sections[sectionIndex]), tt && substractTts(tt, currTt))

	currTt = addTts(currTt, yLineTt)
	globalLineIndex += lineIndex
	// console.log({ tt, count: currTt, sectionIndex })

	if (!twice && tt && compareTts(addTts(currTt, TT_BY_LINE), tt) > -1) {
		return getTtFromY(y, sections, tt, true)// calling twice to handle different offset, changing if going from down to top, or from top to bottom
	}

	return {
		yTt: currTt,
		globalLineIndex
	}
}

// Need to be called with y - editorTop
export const getTtAndLineIndexFromXY = (x: number, y: number, sections: Section[], tt?: string): any => {
	const { yTt, globalLineIndex } = getTtFromY(y, sections, tt)

	return {
		tt: addTts(getTtFromX(x), yTt),
		globalLineIndex,
	}
}


export const getTtFromLineIndexAndTt = (lineIndex: number, tt: string) => {
	const xTt = modTt(tt, BARS_BY_LINE)
	const yTt = (lineIndex * BARS_BY_LINE) + ':0'

	return addTts(yTt, xTt)
}

export const getLineFromTt = (tt: string) =>
	Math.floor(parseInt(tt.split(':')[0]) / BARS_BY_LINE)



export const isIndexInRanges = (i: number, ranges: [number, number][]) =>
	ranges.some((range: [number, number]) => range[0] <= i && i <= range[1])

export const findIndexInRange = (range: [number, number], i: number) =>
	i < range[0] || i > range[1] ? -1 : i - range[0]
	
export const findIndexInRanges = (ranges: [number, number][], i: number) => {
	let count = 0

	for (const range of ranges) {
		const index = findIndexInRange(range, i)
		if (index === -1) {
			if (i < range[0]) {
				return -1
			}
			else {
				count += range[1] - range[0] + 1
			}
		}
		else {
			return count + index
		}
	}

	return -1
}

export const forEachRanges = (ranges: [number, number][], cb: (index: number) => void) => {
	for (const range of ranges) {
		for (let i = range[0]; i <= range[1]; i++) {
			cb(i)
		}
	}
}

export const getLineMaxTt = (globalLineIndex: number) =>
	substractTts((globalLineIndex + 1) * BARS_BY_LINE + ':0', '0:0:1')

export const getLineMinTt = (globalLineIndex: number, ttDuration: string) =>
	substractTts(globalLineIndex * BARS_BY_LINE + ':0', substractTts(ttDuration, '0:0:1'))


export const areRangesEqual = (r1: [any, any], r2: [any, any]) =>
	r1[0] === r2[0] && r1[1] === r2[1]


export const deepCopy = <T>(o: T): T => JSON.parse(JSON.stringify(o))

export const getId = () => '_' + Math.random().toString(36).substr(2, 9)

export const negativMod = (n: number, m: number) => ((n % m) + m) % m

// Maybe use Tone.Time('0:0:1').eval()

// TODO : write log helper for functions (take a function in parameter)
